var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.params)?_c('RolePermissions',{attrs:{"getUrl":`permissions/user-permissions/${_vm.params}`,"submitUrl":`permissions/user-permission-assign/${_vm.params}/`,"hasRoleId":false}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }